@if(link | isExternal:settings?.download) {
<a [href]="link"
    ga4SelectPromotion
    [attr.download]="settings?.download ? settings?.downloadName : null"
    [style.fontWeight]="settings?.weight"
    [promotion_name]="label">
    <span>{{label}}</span>
    <app-svg *ngIf="arrow"
        use="arrow-right"></app-svg>
</a>
} @else if (link | isInternal) {
<a [routerLink]="link"
    ga4SelectPromotion
    [promotion_name]="label"
    [style.fontWeight]="settings?.weight">
    <span>{{label}}</span>
    <app-svg *ngIf="arrow"
        use="arrow-right"></app-svg>
</a>
} @else if (anchor != null) {
    <ul>
        <li>
            <button (click)="goTo(anchor)"
            ga4SelectPromotion
            [promotion_name]="label"
            [style.fontWeight]="settings?.weight"
            class="anchor">
                <span>{{label}}</span>
                <app-svg *ngIf="arrow"
                use="arrow-right"></app-svg>
            </button>
        </li>
    </ul>
}
@else {
<button (click)="runLink()"
        ga4SelectPromotion
        [promotion_name]="label"
        [style.fontWeight]="settings?.weight">
    <span>{{label}}</span>
    <app-svg *ngIf="arrow"
        use="arrow-right"></app-svg>
</button>
}
